var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckWithCircle = function SvgCheckWithCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.86 193.94C33.58 193.94 0 160.36 0 119.08s33.58-74.86 74.86-74.86c10.1 0 19.91 1.98 29.14 5.89l-7.07 16.71c-6.99-2.95-14.41-4.45-22.07-4.45-31.27 0-56.71 25.44-56.71 56.71s25.44 56.71 56.71 56.71 56.71-25.44 56.71-56.71c0-2.41-.15-4.83-.45-7.19l18-2.28c.4 3.11.6 6.3.6 9.47 0 41.28-33.58 74.86-74.86 74.86z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m71.41 147.81-38.52-38.62 12.86-12.81 25.66 25.73L187.15 6.06 200 18.87z"
  })));
};
export default SvgCheckWithCircle;